import type {
  OffersWarningDTO,
  SearchJourneyOffersDTO,
} from '@/types/dto/agent';
import type { OffersWarning, WarningsByTripId } from '@/types/offer';
import _map from 'lodash/map';
import _pick from 'lodash/pick';

export const getWarningsByTripId = (
  warnings: Array<OffersWarningDTO> | undefined
) =>
  warnings?.reduce<WarningsByTripId>((map, warning) => {
    if (!warning.detail) {
      return map;
    }

    map[warning.detail] = _pick(warning, ['type', 'instance', 'code']);

    return map;
  }, {}) || {};

const getWarningMessage = (warning: OffersWarning | null) => {
  if (!warning) {
    return null;
  }

  switch (warning?.code) {
    case 'SOLD_OUT':
      return 'Sold out';
    case 'NOT_ENOUGH_SEATS':
      return 'Not enough seats';
    case 'NOT_AVAILABLE':
      return 'Not available'; // fallback code given by FE
    default:
      return 'Unconfigured warning message.';
  }
};

export const getWarning = (
  tripIds: Array<string>,
  warningsByTripId: WarningsByTripId
) => {
  const warnings = tripIds.map((tripId) => {
    return warningsByTripId[tripId];
  });

  return warnings.length
    ? getWarningMessage(warnings[0])
    : getWarningMessage({ code: 'NOT_AVAILABLE ' });
};

export const getJourneyWarning = (
  journey: SearchJourneyOffersDTO,
  warningsByTripId: WarningsByTripId
): string | null => {
  if (journey.lowestPrice) {
    // we assume no legs are giving warnings if lowestPrice exists on journey
    return null;
  }

  const tripIds = _map(journey.trips, 'id').filter((id): id is string =>
    Boolean(id)
  );

  return getWarning(tripIds, warningsByTripId);
};
// should be refactored once https://youtrack.tsolutions.co/issue/BR-49131 is completed
